import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, MessengerIntegrationsResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof MessengerIntegrationsResponseData>>

const queryKey = ["messengerIntegrations"]

export const messengerIntegrationsQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/messenger`)

      return response.data.data
    },
  })
}
